// --------------------------------------------------------------------------
// MODULE ? – MAP SIGNPOST BLOCK
// --------------------------------------------------------------------------
// Author:      Alex Baulch
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var GoogleMapsLoader = require('google-maps');
GoogleMapsLoader.KEY = 'AIzaSyAp8yQAy-Y3pI6dPwDWFaMjxS47CgroM2w';
GoogleMapsLoader.LIBRARIES = ['places'];

module.exports = function (options) {
    var context = options.context;
    var addressInputField = document.querySelector('[data-binding="address-lookup-field"]');
    var submitThis = {
        lat: '',
        lng: ''
    };

    /**
     * init function for the activities
     */
    function init() {
        GoogleMapsLoader.load(function (google) {
            // set autocomplete options
            var autocompleteOptions = {
                types: ['geocode'],
                componentRestrictions: { country: 'gb' }
            };

            var autocomplete = new google.maps.places.Autocomplete(addressInputField, autocompleteOptions);

            google.maps.event.addListener(autocomplete, 'place_changed', function () {
                var place = autocomplete.getPlace();
                var lat, lng;

                try {
                    lat = place.geometry.location.lat();
                    lng = place.geometry.location.lng();
                } catch (e) {
                    console.log(e);
                }

                submitThis.lat = lat;
                submitThis.lng = lng;
            });
        });
    }

    context.on('submit', function (e) {
        if (submitThis.lat !== '' && submitThis.lng !== '') {
            e.preventDefault();
            var action = context.find('form').attr('action');
            action += '?latitude=' + submitThis.lat + '&longitude=' + submitThis.lng;
            window.location = window.location.protocol + '//' + window.location.host + action + '#map-view';
        } else {
            return false;
        }
    });

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/map-signpost.js
// module id = 212
// module chunks = 0